import { render } from "./ColorDropdown.vue?vue&type=template&id=ff82fcec&scoped=true"
import script from "./ColorDropdown.vue?vue&type=script&lang=js"
export * from "./ColorDropdown.vue?vue&type=script&lang=js"

import "./ColorDropdown.vue?vue&type=style&index=0&id=ff82fcec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ff82fcec"

export default script